<template>
  <div class="d-flex flex-column align-center justify-center py-12">
    <v-icon size="64" color="grey darken-1" class="mb-4">
      mdi-bell-off-outline
    </v-icon>
    <h2 class="text-h6 text-grey-darken-1 mb-2">{{ title }}</h2>
    <p class="text-body-1 text-grey-darken-1 text-center">
      {{ message }}
    </p>
  </div>
</template>
    
<script>
export default {
  name: "AlertsEmptyView",
  props: {
    title: {
      type: String,
      default: "No Alerts Found",
    },
    message: {
      type: String,
      default: "There are currently no alerts to display.",
    },
  },
};
</script>
    
    
      
      